import React, { useState } from "react";
import { motion } from "framer-motion";
import Swal from "sweetalert2";
import { useLanguage } from "../context/LanguageContext";
import sending from "../assets/sending2.gif";
import "./styles/Contact.css";
import contact from '../assets/g9.png';

const ContactSection = () => {
  const { language, t } = useLanguage();
  const isRtl = language === 'ar';
  const [, setIsLoading] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    Swal.fire({
      html: `
        <img src="${sending}" class="sending" alt="Sending animation" />
        <p class="sending-text">${t("contact.sendingMessage")}</p>
      `,
      showConfirmButton: false,
      allowOutsideClick: false,
      background: "#b18edf",
      color: "#2a2a2c",
      customClass: {
        popup: "loading-popup",
      },
      didOpen: () => {
        Swal.getPopup().style.overflow = "hidden";
      },
    });
    try {
      const res = await fetch("/api/send", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, message }),
      });

      await res.json();

      if (res.ok) {
        setIsLoading(false);
        Swal.fire({
          icon: false,
          html: `
            <div class="emoji-container">🎉</div>
            <p>${t("contact.successMessage")}</p>
          `,
          showConfirmButton: true,
          confirmButtonText: t("common.ok"),
          background: "#b18edf",
          customClass: {
            confirmButton: "conform-btn",
            popup: "custom-popup",
          },
        });

        setName("");
        setEmail("");
        setMessage("");
      } else {
        setIsLoading(false);
        Swal.fire({
          icon: false,
          html: `
            <div class="emoji-container-sad">😢</div>
            <p>${t("contact.errorMessage")}</p>
          `,
          showConfirmButton: true,
          confirmButtonText: t("common.ok"),
          background: "#b18edf",
          customClass: {
            confirmButton: "conform-btn",
            popup: "custom-popup",
          },
        });
      }
    } catch (error) {
      setIsLoading(false);
      Swal.fire({
        icon: false,
        html: `
          <div class="emoji-container-sad">😢</div>
          <p>${t("contact.errorMessage")}</p>
        `,
        showConfirmButton: true,
        confirmButtonText: t("common.ok"),
        background: "#b18edf",
        customClass: {
          confirmButton: "conform-btn",
          popup: "custom-popup",
        },
      });
    }
  };

  return (
    <section className="contact-section" id="contact" dir={isRtl ? "rtl" : "ltr"}>
      <div className="stars-bg" />
      <motion.h2
        className="contact-title"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        {t("contact.getInTouch")}
      </motion.h2>

 <motion.div
  style={{
    position: 'relative',
    width: '100px',
    height: '170px',
    marginTop: '50px',
    marginBottom: '40px',
    marginLeft: 'auto',
    marginRight: 'auto',
  }}
  initial={{ opacity: 0, y: -60 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 1, type: "spring", stiffness: 100, damping: 15, mass: 0.8 }}
  viewport={{ once: false, amount: 0.3 }}
>
  <motion.div
    style={{
      position: 'absolute',
      top: '0',
      left: '0',
      transform: 'translate(-50%, -50%)',
      width: '100px',
      height: '100px',
      borderRadius: '50%',
      background: 'radial-gradient(circle, rgba(255,182,193,0.7) 0%, rgba(255,105,180,0.3) 50%, rgba(255,255,255,0) 80%)',
      filter: 'blur(8px)',
      zIndex: 1,
      pointerEvents: 'none',
    }}
    animate={{
      scale: [1, 1.4, 1],
      opacity: [0.6, 1, 0.6],
      boxShadow: [
        '0 0 0px rgba(255,182,193,0)',
        '0 0 30px 10px rgb(255, 255, 255)',
        '0 0 0px rgba(255, 255, 255, 0.92)',
      ],
    }}
    transition={{
      duration: 1.8,
      repeat: Infinity,
      ease: "easeInOut",
    }}
  />
  <motion.img
    src={contact}
    alt="contact-image"
    style={{
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      position: 'relative',
      zIndex: 2,
      filter: 'drop-shadow(0 0 4px rgba(255,215,235,0.5))'
    }}
    animate={{
      scale: [1, 1.02, 1], 
      filter: [
        'drop-shadow(0 0 4px rgba(255,215,235,0.5))',
        'drop-shadow(0 0 12px rgba(255,105,180,0.7))',
        'drop-shadow(0 0 4px rgba(255,215,235,0.5))',
      ],
    }}
    transition={{
      duration: 1.9,
      repeat: Infinity,
      ease: "easeInOut",
    }}
     whileHover={{
    scale: 1.2,              
    filter: 'drop-shadow(0 0 25px rgba(255,160,200,1)) brightness(1.15)',
    transition: { duration: 0.3, type: "spring", stiffness: 300 }
  }}
    whileTap={{
    scale: 1.2,              
    filter: 'drop-shadow(0 0 25px rgba(255,160,200,1)) brightness(1.15)',
    transition: { duration: 2, type: "spring", stiffness: 300 }
  }}
  />
</motion.div>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        viewport={{ once: false }}
        dangerouslySetInnerHTML={{ __html: t("contact.subtitle") }}
      />

      <form className="contact-form" onSubmit={handleSubmit}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: false }}
          animate={{
            boxShadow: [
              "0 0 0px rgba(255, 255, 255, 0)",
              "0 0 20px rgba(255, 255, 255, 0.4)",
              "0 0 0px rgba(255, 255, 255, 0)",
            ],
          }}
        >
          <input
            type="text"
            name="name"
            value={name}
            placeholder={t("contact.yourName")}
            onChange={(e) => setName(e.target.value)}
            className={name ? "filled" : ""}
            required
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          viewport={{ once: false }}
          animate={{
            boxShadow: [
              "0 0 0px rgba(255, 255, 255, 0)",
              "0 0 20px rgba(255, 255, 255, 0.4)",
              "0 0 0px rgba(255, 255, 255, 0)",
            ],
          }}
        >
          <input
            type="email"
            name="email"
            placeholder={t("contact.yourEmail")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={email ? "filled" : ""}
            required
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.4 }}
          viewport={{ once: true }}
          animate={{
            boxShadow: [
              "0 0 0px rgba(255, 255, 255, 0)",
              "0 0 20px rgba(255, 255, 255, 0.4)",
              "0 0 0px rgba(255, 255, 255, 0)",
            ],
          }}
        >
          <textarea
            name="message"
            placeholder={t("contact.yourMessage")}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className={message ? "filled" : ""}
            required
          />
        </motion.div>

        <motion.button
          className="send-btn"
          type="submit"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          transition={{ type: "spring", stiffness: 300 }}
        >
          {t("contact.sendMessage")}
        </motion.button>
      </form>

      <motion.div
        className="contact-links"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.8, duration: 0.6 }}
        viewport={{ once: false }}
      />
    </section>
  );
};

export default ContactSection;